import { render, staticRenderFns } from "./v-audio.vue?vue&type=template&id=b3c48fc2&scoped=true&"
import script from "./v-audio.vue?vue&type=script&lang=js&"
export * from "./v-audio.vue?vue&type=script&lang=js&"
import style0 from "./v-audio.vue?vue&type=style&index=0&id=b3c48fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c48fc2",
  null
  
)

export default component.exports